// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Dvro","left":"StickyBox_left__2N29s","right":"StickyBox_right__3LVCc"};